import '../vendor';

import '../general/ofi';
import '../general/tooltip';

import './game-one/game-title';
import './one-exponat/modal-exponat';
import './game-one/game-slider';
import './game-one/game-answers-images';
import './page-video/full-sl-img';


// WEBPACK FOOTER //
// ./src/js/pages/game-one-images.js